// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-display-total-value',
    templateUrl: './display-total-value.component.html',
    styleUrls: ['./display-total-value.component.scss', '../dynamic-dashboard.common.scss'],
    standalone: false
})
export class DisplayTotalValueComponent {
  @Input() title: string;
  @Input() total: number | undefined;
  @Input() routeLink: string | null;
  @Input() routeQueryParams: {[p: string]: any} | undefined | null;
  @Input() loading: boolean;
}
